<template>
  <div>
    <h3
      class="boss-joboffer-title boss-setting"
      data-test="title"
    >
      {{ title }}
    </h3>
    <p
      v-if="description"
      class="boss-text margin-top-0 margin-bottom-1"
      data-test="description"
    >
      {{ description }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: false,
      default: ''
    }
  }
}
</script>
